import React from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { isAddressIncomplete } from '@common/utils/orderHelper';
import { Tag, Tooltip } from 'antd';
import PropTypes from 'prop-types';

// 住所の状態を断定せず、あくまで自動判定の結果として伝える。
// カタカナ表記・ローマ字表記・郡名の略記など、住所自体は正しくても
// 判定ロジックが読み取れないケースがあるため（レベル0に多い）。
const ADDRESS_LEVEL_MESSAGE = {
  0: '住所を自動判定できませんでした。内容をご確認ください',
  1: '都道府県までしか読み取れませんでした。番地までご確認ください',
  2: '市区町村までしか読み取れませんでした。番地までご確認ください',
  3: '番地が見当たりません。精算時の運賃計算に必要なためご確認ください',
};

function AddressAlertTag({ addressLevel }) {
  if (!isAddressIncomplete(addressLevel)) return null;

  return (
    <Tooltip
      title={ADDRESS_LEVEL_MESSAGE[addressLevel] ?? '住所をご確認ください'}
    >
      <Tag
        color="orange"
        icon={<ExclamationCircleOutlined />}
        className="address-alert-tag"
      >
        住所要確認
      </Tag>
    </Tooltip>
  );
}

export default AddressAlertTag;

AddressAlertTag.propTypes = {
  addressLevel: PropTypes.number,
};
